// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3CHIm","image":"Header_image__3-nct","name":"Header_name__3R2Fp","info":"Header_info__2XHMz","infoRow":"Header_infoRow__3luuv"};